import React, { useState } from "react";
import { FaFileCode, FaCopy, FaDownload, FaCheck } from "react-icons/fa";
import { downloadHtml } from "../AbTestStudio";

// Compact file card for a generated UI artifact (shown inline in the chat).
// No live preview here — just the file, its description, and Copy/Download/Open.
export default function ArtifactCard({ artifact, onOpen }) {
  const [copied, setCopied] = useState(false);
  if (!artifact?.html) return null;

  const fileName =
    (artifact.variantName || "variant").replace(/[^a-z0-9-_]+/gi, "-") + ".html";
  const desc =
    artifact.description ||
    artifact.explanation ||
    `Generated UI for ${artifact.page || "your page"}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(artifact.html);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className="w-full rounded-xl border border-cyan-200 bg-white p-3 shadow-sm">
      <div className="flex items-start gap-2.5">
        <div className="w-9 h-9 rounded-lg bg-cyan-50 border border-cyan-200 flex items-center justify-center text-cyan-600 shrink-0">
          <FaFileCode />
        </div>
        <div className="min-w-0 flex-grow">
          <p className="text-xs font-bold text-slate-800 truncate">{fileName}</p>
          <p className="text-[11px] text-slate-500 line-clamp-2">{desc}</p>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-2.5">
        <button
          onClick={copy}
          className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-slate-200 bg-white text-[11px] font-semibold text-slate-600 hover:bg-slate-50"
          title="Copy HTML"
        >
          {copied ? <FaCheck className="text-[10px] text-emerald-500" /> : <FaCopy className="text-[10px]" />}
          {copied ? "Copied" : "Copy"}
        </button>
        <button
          onClick={() => downloadHtml(artifact.html, artifact.variantName)}
          className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-slate-200 bg-white text-[11px] font-semibold text-slate-600 hover:bg-slate-50"
          title="Download .html"
        >
          <FaDownload className="text-[10px]" /> Download
        </button>
        {onOpen && (
          <button
            onClick={onOpen}
            className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-slate-900 text-white text-[11px] font-semibold hover:bg-slate-800"
            title="Open in studio"
          >
            Open in studio
          </button>
        )}
      </div>
    </div>
  );
}
